import { render, staticRenderFns } from "./WebsitePhpPricing.vue?vue&type=template&id=56db04b6&scoped=true&"
import script from "./WebsitePhpPricing.vue?vue&type=script&lang=js&"
export * from "./WebsitePhpPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db04b6",
  null
  
)

export default component.exports